/* eslint-disable @angular-eslint/no-output-native */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  OnDestroy,
  Type,
  inject,
} from '@angular/core';
import { ModalService } from 'app/services/modal.service';
import { DialogModule } from 'primeng/dialog';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [DialogModule, NgStyle],
})
export class ModalComponent implements OnDestroy {
  @ViewChild('insertPoint', { read: ViewContainerRef })
  insertContentPoint: ViewContainerRef;

  // tslint:disable-next-line: variable-name
  @Input() className: string;
  @Input() set display(displayValue: boolean) {
    this._display = displayValue;
    if (displayValue) {
      this.contentComponentRef?.instance?.open?.();
    }
  }
  @Input()
  set contentComponent(ComponentClass: Type<any>) {
    this.buildContentComponent(ComponentClass);
  }
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() hide = new EventEmitter();
  @Output() displayed = new EventEmitter();
  // tslint:disable-next-line: no-output-native
  @Output() close = new EventEmitter<never>();
  @Output() contentComponentBuilded = new EventEmitter<Component>();

  _display: boolean;
  contentComponentRef: ComponentRef<any>;

  public modalService: ModalService = inject(ModalService);


  visibilityChange(): void {
    this._display = !this._display;
    if (this._display) {
      this.hide.emit();
    }
    this.displayed.emit();
    this.displayChange.emit(this._display);
  }

  buildContentComponent(ComponentClass: Type<any>): void {
    if (!this.insertContentPoint) {
      return;
    }

    this.insertContentPoint.clear();
    if (this.insertContentPoint && ComponentClass) {
      this.contentComponentRef =
        this.insertContentPoint.createComponent(ComponentClass);
      // Emit component when it's builded
      this.contentComponentBuilded.emit(this.contentComponentRef.instance);
    }
  }

  ngOnDestroy(): void {
    this.modalService.setDialogComponent(null, true);
    this.contentComponentRef?.destroy();
  }
}
